'use strict';

var _classCallCheck = require("/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _core = require('@react-navigation/core');

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getTopNavigation = function getTopNavigation(navigation) {
  var parent = navigation.dangerouslyGetParent();

  if (parent) {
    return getTopNavigation(parent);
  }

  return navigation;
};

var LinkWithNavigation = /*#__PURE__*/function (_react$Component) {
  _inherits(LinkWithNavigation, _react$Component);

  var _super = _createSuper(LinkWithNavigation);

  function LinkWithNavigation() {
    _classCallCheck(this, LinkWithNavigation);

    return _super.apply(this, arguments);
  }

  _createClass(LinkWithNavigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          params = _this$props.params,
          routeName = _this$props.routeName,
          routeKey = _this$props.routeKey,
          navigation = _this$props.navigation,
          action = _this$props.action;
      var topNavigation = getTopNavigation(navigation);
      var topRouter = topNavigation.router;

      var navAction = action || _core.NavigationActions.navigate({
        routeName: routeName,
        key: routeKey,
        params: params
      });

      if (!action && !routeName && !routeKey) {
        throw new Error('Must provide a routeName, routeKey, or a navigation action prop to <Link>');
      }

      if (action && routeKey) {
        throw new Error('Cannot specify a conflicting "routeKey" and a navigation "action" prop. Either use routeName with routeKey to specify a navigate action, or provide the specific navigation "action" prop.');
      }

      if (action && routeName) {
        throw new Error('Cannot specify a conflicting "routeName" and a navigation "action" prop. Either use routeName with routeKey to specify a navigate action, or provide the specific navigation "action" prop.');
      }

      var navActionResponse = topRouter.getStateForAction(navAction, topNavigation.state);
      var nextState = navActionResponse === null ? topNavigation.state : navActionResponse;
      var pathAndParams = topRouter.getPathAndParamsForState(nextState);
      var href = Object.keys(pathAndParams.params).length ? "/".concat(pathAndParams.path, "?").concat(_queryString2.default.stringify(pathAndParams.params)) : "/".concat(pathAndParams.path);
      return _react2.default.createElement('a', {
        href: href,
        onClick: function onClick(e) {
          navigation.dispatch(navAction);
          e.preventDefault();
        }
      }, children);
    }
  }]);

  return LinkWithNavigation;
}(_react.Component);

var Link = (0, _core.withNavigation)(LinkWithNavigation);
exports.default = Link;